import { render, staticRenderFns } from "./DeliveryTl.vue?vue&type=template&id=fba82aa6&scoped=true&"
import script from "./DeliveryTl.vue?vue&type=script&lang=js&"
export * from "./DeliveryTl.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTl.vue?vue&type=style&index=0&id=fba82aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba82aa6",
  null
  
)

export default component.exports